import React, { Fragment, useState } from "react";
import { Box, Grid2 as Grid, Stack, Typography } from "@mui/material";
import { FormTextField } from "../../../generic/GenericTextFields";
import { CaretUp, Plus } from "@phosphor-icons/react";

export const PlatformsAndSocials = ({ fields, title, subTitle, formik, followerCount, handleChangeFollowerCount, ...others }) => {
  const [isShowMore, setIsShowMore] = useState(false);

  const handleToggleShowMore = () => {
    setIsShowMore(prev => !prev);
  };

  const handleChange = (id, value) => {
    formik.setFieldValue(id, value);
    if (value === '') {
      handleChangeFollowerCount(id, '');
    }
  };

  return (
    <Box {...others}>
      <Typography variant="subtitle1" fontWeight={700}>{title}</Typography>
      <Typography>Please fill out at least {subTitle}.</Typography>
      <Grid container mt={3} spacing={1.5}>
        {
          fields?.slice(0, isShowMore ? fields.length : 6)?.map((item, index) => {
            const showCountField = followerCount && item?.meta?.showFollowerCount;
            const categoryHasValue = (!!formik?.values[item?.id]);
            const isValid = (categoryHasValue && (!followerCount?.[item?.id] || followerCount?.[item?.id] < 0));
            return (
              <Grid container item size={{ xs: 12, sm: 6 }} key={`platform-key-${index}`}>
                <Grid item size={(showCountField && categoryHasValue) ? 7.5 : 12}>
                  <FormTextField
                    value={formik?.values[item?.id]}
                    isRequired={false}
                    placeholder={item?.meta?.placeholder}
                    label={item?.name}
                    handleChange={(value) => handleChange(item?.id, value)}
                  />
                </Grid>
                {
                  categoryHasValue && <Fragment>
                    {
                      showCountField && <Grid item size={4.5}>
                        <FormTextField
                          inputProps={{ min: 10 }}
                          value={followerCount?.[item?.id]}
                          label={'Followers'}
                          type={'number'}
                          placeholder={'Follower count'}
                          handleChange={(value) => {
                            if (value.length <= 10) {
                              handleChangeFollowerCount(item?.id, value);
                            }
                          }}
                          isRequired={false}
                          error={isValid}
                          helperText={isValid && 'Required'}
                        />
                      </Grid>
                    }
                  </Fragment>
                }
              </Grid>
            );
          })
        }
        <Stack
          direction={'row'}
          alignItems={'center'}
          color={'primary.main'}
          gap={1}
          mt={1}
          justifyContent={'center'}
          width={'100%'}
          onClick={() => handleToggleShowMore()}
        >
          {isShowMore ? <CaretUp size={16} weight="bold" /> : <Plus size={16} weight="bold" />}
          <Typography fontWeight={600} sx={{ cursor: 'pointer' }}>{isShowMore ? 'Show Less' : 'Show More'}</Typography>
        </Stack>
      </Grid>
    </Box >
  );
};